$("#scroll-top").on("click", function () {
  $("html, body").animate(
    {
      scrollTop: $(".top").offset().top - 80,
    },
    2000
  );
});
